import { useEffect } from "react";
import { getPortalUrl } from "@jari-tools/shared";
import "@jari-tools/shared/components/paywall.css";

const CONTENT_MAIL = "rianne@interactggz.nl";

interface PreviewNudgeProps {
  onDismiss: () => void;
  portalUrl?: string;
  toolSlug: string;
}

export function PreviewNudge({ onDismiss, portalUrl, toolSlug }: PreviewNudgeProps) {
  const purchaseUrl = `${getPortalUrl(portalUrl)}/kopen/${encodeURIComponent(toolSlug)}`;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onDismiss();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onDismiss]);

  return (
    <div
      className="jari-paywall-modal-backdrop bloom-preview-nudge"
      role="dialog"
      aria-modal="true"
      aria-labelledby="bloom-preview-nudge-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) e.preventDefault();
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onDismiss();
      }}
    >
      <div className="jari-paywall-modal">
        <h2 id="bloom-preview-nudge-title">Verder gebruiken?</h2>
        <p>
          Je hebt deze tool nu drie keer uitgeprobeerd. Deze melding komt nu na elke 5 beantwoorde
          vragen. Wil je &apos;m verder gebruiken, kun je de tool nu aanschaffen.
        </p>
        <div className="jari-paywall-modal__actions">
          <a href={purchaseUrl} className="jari-btn jari-btn--primary">
            Kopen
          </a>
          <button
            type="button"
            className="jari-btn"
            onMouseDown={(e) => e.preventDefault()}
            onClick={onDismiss}
          >
            Sluiten
          </button>
        </div>
        <p className="jari-guest-access__portal">
          Wil je meer weten over de inhoud? Stuur ons een mailtje op{" "}
          <a href={`mailto:${CONTENT_MAIL}`}>{CONTENT_MAIL}</a>.
        </p>
      </div>
    </div>
  );
}
